// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"ProfileLoading_wrapperComponent__R+Hgz","progress":"ProfileLoading_progress__DdYpL"};